// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Oi1nj","actions":"GroupTable_actions__1lY8B","deleteModalFooter":"GroupTable_deleteModalFooter__1SafG"};